<template>

    <div >
        <h3>Tenant Logos</h3>

        <ValidationProvider name="Tenant Logos"
                            ref="tenantLogosLength"
                            rules="max_value:0" :custom-messages="{ max_value: 'Please assign All logos to tenants' }" v-slot="{ passed, failed }">
            <input type="hidden" v-model="files.tenantLogos.length" />
            <p>
                Assign <b>all</b> to relevant tenants
                <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
            </p>

            <draggable :list="files.tenantLogos" class="list-group source-list logos_list"
                       :sort="false" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files">
                <file-item v-for="file in files.tenantLogos"
                           :key="file.id" :file="file"
                           class="list-group-item md-elevation-5"></file-item>
            </draggable>

        </ValidationProvider>

    </div>
</template>

<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate"; //TODO:validate properly https://github.com/logaretm/vee-validate/issues/294    //looks like need the name to be unique so need an index https://jsfiddle.net/hf96yxxy/8/ https://vee-validate.logaretm.com/v2/guide/conditional-and-looping-inputs.html#handling-v-for
    import { required, min, max } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);

    import draggable from 'vuedraggable';
    import FileItem from "./FileItem.vue";

    export default {
        components: {
            SlideYDownTransition,
            draggable,
            FileItem
        },
        props: {
            files: null,
        }
    }
</script>

<style lang="scss">
    /* No idea why this was missing, stole from inspecting https://vuematerial.io/components/button/
        Without it, md-icon-buttons were not round !!! WTF ???
    */

    .md-icon-button {
        width: 40px;
        min-width: 40px;
        height: 40px;
        margin: 0 6px;
    }

    .md-fab, .md-icon-button {
        border-radius: 50%;
        z-index: 6;
    }

    .paginated-table .md-table-cell .md-table-cell-container,
    .paginated-table .md-table-head {
        padding-right: 10px;
        padding-left: 10px;
    }

   

    .actions-container {
        text-align: center;
    }

    .tenants-info-table .md-table-row {
        overflow-y: visible !important;
    }

    .tenants-info-table.md-table {
        margin-top: 4rem;
        overflow-y: visible !important;
    }

        .tenants-info-table.md-table .md-table-content {
            overflow-y: visible !important;
        }

    .md-steppers-wrapper {
        overflow-y: visible !important;
    }


    .paginated-table .md-table-head:last-child {
        display: table-cell !important;
    }

    .paginated-table .md-table-cell:last-child .md-table-cell-container,
    .paginated-table .md-table-head:last-child {
        text-align: left !important;
        /* text-align: right !important; */
        /* display: -webkit-box; */
        /*display: -ms-flexbox;*/
        /* display: flex; */
        /* -webkit-box-pack: end; */
        /*-ms-flex-pack: end;*/
        /* justify-content: flex-end; */
    }

    .paginated-table .md-table-cell:last-child .md-table-cell-container {
        display: block !important;
    }

    .md-icon.md-icon-font.md-theme-default.error {
        color: red;
    }

    .md-icon.md-icon-font.md-theme-default.success {
        color: green;
    }
</style>
